/* eslint-disable no-console */
const fetchJSON = require('./fetchJSON.js');

function reduceResponses(responses, serviceKeys) {
    return serviceKeys.reduce((acc, key, index) => ({
        ...acc,
        [key]: responses[index],
    }), {});
}

module.exports = async function fetchCompositeJSON(services = {}, options = { timeout: 30000 }) {
    const serviceKeys = Object.keys(services);

    const servicePromises = serviceKeys.map((serviceKey) => {
        const service = services[serviceKey];

        // If the service is a string we construct a fetch
        // eslint-disable-next-line
        if (typeof service == 'string') {
            return fetchJSON(service, options);
        }

        // return pre-constructed fetch calls
        return service;
    }).map((promise) => promise.catch((error) => error));

    return Promise.all(servicePromises)
        .then((responses) => reduceResponses(responses, serviceKeys))
        .catch((error) => console.error(error));
};
